import { cn } from '../lib/cn';

export interface StepDef {
  label: string;
  done: boolean;
}

// Shared horizontal stepper used by the New Order / New Quotation wizards.
// Click a step to jump to it (the parent decides via `onStep` whether the jump
// is allowed — typically only to already-valid earlier steps).
export function Stepper({
  steps,
  current,
  onStep,
}: {
  steps: StepDef[];
  current: number;
  onStep: (i: number) => void;
}): JSX.Element {
  return (
    <div className="flex items-center gap-0 bg-surface rounded-lg border border-rule px-4 py-3">
      {steps.map((s, i) => {
        const n = i + 1;
        const isCurrent = n === current;
        return (
          <div key={s.label} className="flex items-center flex-1 last:flex-none">
            <button
              type="button"
              onClick={() => onStep(n)}
              className="flex items-center gap-2 group focus:outline-none"
            >
              <span
                className={cn(
                  'w-6 h-6 rounded-full text-xs font-medium flex items-center justify-center border transition',
                  isCurrent
                    ? 'bg-accent text-white border-accent'
                    : s.done
                      ? 'bg-positive text-white border-positive'
                      : 'bg-paper-2 text-ink-3 border-rule',
                )}
              >
                {s.done && !isCurrent ? '✓' : n}
              </span>
              <span
                className={cn(
                  'text-sm transition',
                  isCurrent
                    ? 'text-ink font-medium'
                    : s.done
                      ? 'text-ink group-hover:text-accent'
                      : 'text-ink-3',
                )}
              >
                {s.label}
              </span>
            </button>
            {i < steps.length - 1 && (
              <div className={cn('flex-1 h-px mx-3', s.done ? 'bg-positive' : 'bg-rule')} />
            )}
          </div>
        );
      })}
    </div>
  );
}
